"use strict";
/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrowCDownIcon = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var forwardRef_1 = require("../../helpers/forwardRef");
var Icon_1 = require("../../internal/Icon");
var ArrowCDownIcon16Light_1 = require("./ArrowCDownIcon16Light");
var ArrowCDownIcon16Regular_1 = require("./ArrowCDownIcon16Regular");
var ArrowCDownIcon16Solid_1 = require("./ArrowCDownIcon16Solid");
var ArrowCDownIcon20Light_1 = require("./ArrowCDownIcon20Light");
var ArrowCDownIcon20Regular_1 = require("./ArrowCDownIcon20Regular");
var ArrowCDownIcon20Solid_1 = require("./ArrowCDownIcon20Solid");
var ArrowCDownIcon24Regular_1 = require("./ArrowCDownIcon24Regular");
var ArrowCDownIcon24Solid_1 = require("./ArrowCDownIcon24Solid");
var ArrowCDownIcon32Regular_1 = require("./ArrowCDownIcon32Regular");
var ArrowCDownIcon64Regular_1 = require("./ArrowCDownIcon64Regular");
var sizes = {
    16: {
        light: ArrowCDownIcon16Light_1.ArrowCDownIcon16Light,
        regular: ArrowCDownIcon16Regular_1.ArrowCDownIcon16Regular,
        solid: ArrowCDownIcon16Solid_1.ArrowCDownIcon16Solid,
    },
    20: {
        light: ArrowCDownIcon20Light_1.ArrowCDownIcon20Light,
        regular: ArrowCDownIcon20Regular_1.ArrowCDownIcon20Regular,
        solid: ArrowCDownIcon20Solid_1.ArrowCDownIcon20Solid,
    },
    24: {
        regular: ArrowCDownIcon24Regular_1.ArrowCDownIcon24Regular,
        solid: ArrowCDownIcon24Solid_1.ArrowCDownIcon24Solid,
    },
    32: {
        regular: ArrowCDownIcon32Regular_1.ArrowCDownIcon32Regular,
    },
    64: {
        regular: ArrowCDownIcon64Regular_1.ArrowCDownIcon64Regular,
    },
};
exports.ArrowCDownIcon = forwardRef_1.forwardRef('ArrowCDownIcon', function (props, ref) {
    return react_1.default.createElement(Icon_1.Icon, tslib_1.__assign({ ref: ref }, props, { sizes: sizes }));
});
